// extracted by mini-css-extract-plugin
export default {"root":"client__src__components__file-asset-list__root","fileAsset":"client__src__components__file-asset-list__fileAsset"};